import Page from "layouts/Page";
import { Divider, Heading, Box } from "@chakra-ui/react";

export default function () {
  return (
    <Page>
      <Box bg="white" p={6} my={6} borderRadius="xl" boxShadow={"xl"}>
        <article>
          <Heading>Mentions légales</Heading>
          <Divider />
          <p>En vigueur au 01/04/2022</p>
          <section>
            <p>
              Conformément aux dispositions des Articles 6-III et 19 de la Loi
              n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie
              numérique, dite L.C.E.N., il est porté à la connaissance des
              utilisateurs et visiteurs, ci-après l’"Utilisateur", du site
              www.tete-en-lair.fr, ci-après le "Site", les présentes mentions
              légales.
              <br />
              <br />
              La connexion et la navigation sur le Site par l’Utilisateur
              implique acceptation intégrale et sans réserve des présentes
              mentions légales.
              <br />
              <br />
              Ces dernières sont accessibles sur le Site à la rubrique «
              Mentions légales ».
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 1 - L'EDITEUR</Heading>
            <p>
              L'édition du Site est assurée par Never Stop au capital de 1000
              euros, immatriculée au Registre du Commerce et des Sociétés de
              Poitiers sous le numéro A 839 842 069 dont le siège social est
              situé au 8, Mirbazin 86700 Payré.
              <br />
              Numéro de téléphone 0610487976
              <br />
              Adresse e-mail : contactete-en-lair.fr
              <br />
              Le Directeur de la publication est Benjamin BARBE <br />
              <br />
              ci-après l'"Editeur".
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 2 - L'HEBERGEUR</Heading>
            <p>
              L'hébergeur du Site est la société o2switch, dont le siège social
              est situé au 222-224 Boulevard Gustave Flaubert 63000
              Clermont-Ferrand, avec le numéro de téléphone : 04 44 44 60 40.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 3 - ACCES AU SITE</Heading>
            <p>
              Le Site est accessible en tout endroit, 7j/7, 24h/24 sauf cas de
              force majeure, interruption programmée ou non et pouvant découlant
              d’une nécessité de maintenance.
              <br />
              <br />
              En cas de modification, interruption ou suspension du Site,
              l'Editeur ne saurait être tenu responsable.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 4 - COLLECTE DES DONNEES</Heading>
            <p>
              Le Site assure à l'Utilisateur une collecte et un traitement
              d'informations personnelles dans le respect de la vie privée
              conformément à la loi n°78-17 du 6 janvier 1978 relative à
              l'informatique, aux fichiers et aux libertés.
              <br />
              <br />
              En vertu de la loi Informatique et Libertés, en date du 6 janvier
              1978, l'Utilisateur dispose d'un droit d'accès, de rectification,
              de suppression et d'opposition de ses données personnelles.
              L'Utilisateur exerce ce droit :
              <br />
              <br />
              Toute utilisation, reproduction, diffusion, commercialisation,
              modification de toute ou partie du Site, sans autorisation de
              l’Editeur est prohibée et pourra entraînée des actions et
              poursuites judiciaires telles que notamment prévues par le Code de
              la propriété intellectuelle et le Code civil.
              <br />
              Pour plus d’informations, se reporter aux CGV du site
              www.tet-en-lair.fr accessible à la rubrique "CGV" <br />
              Pour plus d'informations en matière de protection des données à
              caractère personnel, se reporter à la Charte en matière de
              protection des données à caractère personnel du site
              www.tet-en-lair.fr accessible à la rubrique "Données
              personnelles".
              <br />
              Pour plus d'informations en matière de cookies, se reporter à la
              Charte en matière de cookies du site www.tet-en-lair.fr accessible
              à la rubrique "Cookies".
            </p>
          </section>
        </article>
      </Box>
    </Page>
  );
}
